import React, { useEffect, useState } from "react";
import { EditVariantSubmit, VariantListApi } from "services/apiService";
import DynamicButton from "../../common/DynamicButton";
import CommonTable from "common/CommonTable";
import loadingImage from "../../assect/loadingSvg/loading.svg";
import {
  faCirclePlus,
  faFloppyDisk,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { Button, Pagination } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import VariantCreate from "./VaraiantCreate";

const VariantList = () => {
  const [variantList, setVariantList] = useState([]);
  const [open, setOpen] = useState(false);
  const [variantSearch, setvariantListSearch] = useState<string>("");
  const [loader, setLoader] = useState(false);
  const [itemsPerPage] = useState<number>(10);
  const headers = ["Sr.No", "Name", "slug", "status", "Action"];
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [editMode, setEditMode] = useState<number | null>(null);
  const [editValue, setEditValue] = useState<string>("");
  const [editSlug, setEditslug] = useState<string>("");
  const [editStatus, setEditStatus] = useState<number | null>(null);

  useEffect(() => {
    fetchVariantUserList();
  }, []);

  const fetchVariantUserList = async () => {
    setLoader(true);
    try {
      const response = await VariantListApi();
      if (response.status_code === 200) {
        setVariantList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  const handleEditClick = (variant: any) => {
    setEditMode(variant.variant_label_id);
    setEditValue(variant.variant_label_name);
    setEditslug(variant.variant_slug);
    setEditStatus(variant.is_active);
  };
  const handleSaveClick = async (variantId: number) => {
    try {
      const payload = {
        variant_label_id: variantId,
        name: editValue,
        slug: editSlug,
        image_path: null,
        is_active: editStatus,
      };

      const response = await EditVariantSubmit(payload);
      if (response.status_code === 200) {
        fetchVariantUserList();
        setEditMode(null);
        toast.success("Updated variant successfully");
      }
    } catch (error) {
      toast.error("Failed to update variant");
    }
  };
  const renderRow = (variant: any, index: number) => {
    return (
      <tr className="mt-2 pt-4" key={index}>
        <td>{index + 1}</td>
        <td className="table_product_name">
          {editMode === variant.variant_label_id ? (
            <input
              type="text"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="form-control"
              style={{ width: "100%" }}
            />
          ) : (
            <span style={{ textTransform: "uppercase" }}>
              {variant?.variant_label_name}
            </span>
          )}
        </td>
        <td className="table_product_name">
          <span style={{ color: "grey" }}>{variant?.variant_slug}</span>
        </td>

        <td className="align-content-center">
          {editMode === variant.variant_label_id ? (
            <select
              className="form-control"
              value={editStatus ?? variant.is_active}
              onChange={(e) => setEditStatus(Number(e.target.value))}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          ) : (
            <span
              style={{
                color: variant.is_active === 1 ? "green" : "red",
                backgroundColor:
                  variant.is_active === 1 ? "#e0f7e9" : "#f8d7da",
                padding: "5px 10px",
                borderRadius: "5px",
                display: "inline-block",
              }}
            >
              {variant?.is_active === 1 ? "Active" : "Inactive"}
            </span>
          )}
        </td>
        <td className="align-content-center">
          {editMode === variant.variant_label_id ? (
            <DynamicButton
              icon={faFloppyDisk}
              label="Save"
              onClick={() => handleSaveClick(variant.variant_label_id)}
            />
          ) : (
            <DynamicButton
              icon={faPen}
              onClick={() => handleEditClick(variant)}
              iconStyle={{ color: "#63E6BE" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
            />
          )}
        </td>
      </tr>
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setvariantListSearch(value);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const filteredSellers = variantList
    ?.filter((seller: any) =>
      seller.variant_label_name
        ?.toLowerCase()
        .includes(variantSearch.toLowerCase())
    )
    .slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(variantList?.length / itemsPerPage);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  const endIndex = Math.min(startIndex + itemsPerPage, variantList?.length);

  return (
    <div>
      <>
        <div className="d-flex justify-content-between">
          <div className="col-lg-6">
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "0px" }}
              onClick={() => setOpen(true)}
            >
              <FontAwesomeIcon
                icon={faCirclePlus}
                style={{ marginRight: "10px" }}
              />
              Create Variant
            </Button>
          </div>
          <div className="col-lg-5 d-flex mb-3">
            <input
              type="text"
              placeholder="Search Variants..."
              className="form-control"
              style={{ boxShadow: "none" }}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="product-table-container">
          <div className="product-table-content">
            {loader ? (
              <div className="loadingsvg-Image text-center">
                <img
                  src={loadingImage}
                  width={150}
                  height={150}
                  alt="Loading..."
                />
              </div>
            ) : (
              <CommonTable
                data={filteredSellers}
                isLoading={loader}
                headers={headers}
                renderRow={renderRow}
              />
            )}
          </div>
          <div className="pagination-container">
            <div className="data-info" style={{ color: "grey" }}>
              <span>
                Showing {startIndex + 1}-{endIndex} of {variantList?.length}
              </span>
            </div>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              size="large"
            />
          </div>
        </div>
        <VariantCreate
          open={open}
          onClose={() => setOpen(false)}
          onSuccess={() => {
            fetchVariantUserList();
          }}
        />
      </>
    </div>
  );
};

export default VariantList;
